import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'dateFormat',
    pure: true,
    standalone: false
})

@Injectable({
  providedIn: 'root'   // 👈 works here!
})
export class DateFormatPipe implements PipeTransform {
  /**
   * Transforms a date to `DD MMM YYYY` format (default) or a custom format.
   * Locale defaults to 'en-US' (English, Australia compatible).
   */
  transform(
    value: Date | string | number | null | undefined,
    pattern = 'dd MMM yyyy',
    locale = 'en-US'
  ): string {
    if (value === null || value === undefined || value === '') return '-';

    try {
      const date = typeof value === 'string' || typeof value === 'number'
        ? new Date(value)
        : value as Date;

      if (isNaN(date.getTime())) return '-';

      return formatDate(date, pattern, locale).toUpperCase();
    } catch {
      return '-';
    }
  }
}
